import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNonNegative]',
  standalone: true
})
export class NonNegativeDirective {

constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = parseFloat(input.value);

    if (value < 0) {
      input.value = '0';
      if (this.control && this.control.control) {
        this.control.control.setValue(0);
      }
    }
  }

}
